export default {
  currency: {
    style: 'currency', currency: '$'
  },
  app: {
    signin: 'Ingresa',
    signup: 'Registrate',
    or: 'o',
    save: 'Guardar',
    yes: 'Sí',
    no: 'No',
    clickHere: 'Click aquí',
    back: 'Volver',
    info: {
      noResults: 'No hay resultados',
      noMoreResults: 'No hay más resultados'
    },
    delete: 'Eliminar',
    loading: 'Cargando',
    discover: 'Descubrir',
    shop: 'Shop',
    '360': '360',
    latestNews: 'Latest News',
    featuredPlaylist: {
      title: 'Featured Playlist',
      createdBy: 'Creada por'
    },
    recommended: 'Recomendados de BeatHey',
    leaveConfirmation: '¿Está seguro que desea abandonar la página? Se perderá la información ingresada',
    notAllowed: 'Tu usuario no se encuentra autorizado para realizar esta acción.',
    notShowAgain: 'Aceptar'
  },

  form: {
    message: 'Mensaje',
    send: 'Enviar'
  },

  provider: {
    directLink: 'Crear acceso a pantalla de inicio'
  },

  discover: {
    carousels: {
      artists: 'ARTISTAS',
      tracks: 'LO ÚLTIMO',
      playlists: 'PLAYLISTS',
      recommendedPlaylists: 'PLAYLISTS RECOMENDADAS'
    }
  },

  error: {
    emailRequired: 'Debe ingresar un email',
    emailInvalid: 'El email ingresado no es válido',
    emailRepeated: 'El email ingresado ya existe',
    confirmEmailRequired: 'Debe repetir el email ingresado',
    confirmEmailInvalid: 'El email ingresado no coincide',
    valueRequired: 'Debe ingresar un importe',
    valueInvalid: 'El importe debe ser un número',
    valueMinPrice: 'El importe debe ser mayor o igual al mínimo: ',
    voucherInvalid: 'Beneficio inexistente, intentar con otro',
    voucherInactive: 'Beneficio ya no está activo',
    voucherFulled: 'Beneficio agotado',
    shortVoucher: 'El voucher debe tener mas de 10 caracteres',
    longVoucher: 'El voucher debe tener menos de 15 caracteres',
    trackNameRequired: 'Debe ingresar un nombre para el track',
    albumNameRequired: 'Debe ingresar un nombre para el album',
    trackFileRequired: 'Debe Subir un Track',
    iswcErrorCode: 'El codigo ISWC debe respetar el formato T-xxxxxxxxx-x',
    genreRequired: 'Debe ingresar un género para el track',
    usernameRequired: 'Debe ingresar un nombre de usuario',
    usernameRepeated: 'El nombre de usuario ya existe',
    idRequired: 'Debe ingresar un número de identificación personal',
    shortId: 'El número de identificación personal ingresado es demasiado corto',
    phoneInvalid: 'El teléfono ingresado no es válido',
    addressRequired: 'Debe ingresar su dirección',
    birthdateRequired: 'Debe ingresar su fecha de nacimiento completa',
    confirmPasswordInvalid: 'Las contraseñas deben coincidir',
    passwordRequired: 'Debe ingresar una contraseña',
    nameRequired: 'Debe ingresar un nombre',
    messageRequired: 'Debe ingresar una consulta',
    messageMaxLength: 'El mensaje es muy largo. Cantidad másxima de caracteres es 2048',
    playlistRequired: 'Debe seleccionar una playlist',
    playlistNameRequired: 'Debe ingresar el nombre de la playlist',
    trackUpload: 'Error al guardar el track',
    albumUpload: 'Error al guardar el album',
    minPriceRequired: 'Este campo es requerido',
    minPriceValue: 'El valor no puede ser menor a 1 dólar',
    pictureRequired: 'Debe Subir una Imagen',
    store: {
      network: 'Error de red',
      userValidation: 'Error al validar el usuario',
      paymentLink: 'Error al obtener el link de pago',
      myFavorites: 'Error al cargar mis favoritos',
      myTracks: 'Error al cargar mis tracks',
      myPlaylists: 'Error al cargar mis playlists',
      voteValidation: 'Error al verificar los votos',
      data: 'Error al cargar los datos',
      artists: 'Error al cargar los artistas',
      playlists: 'Error al cargar las playlists',
      tracks: 'Error al cargar los tracks',
      voteQuote: 'Ya votaste a 3 artistas! En el próximo mes contarás con 3 votos nuevos para seguir votando',
      SameArtistAndUser: 'No podés votarte a vos mismo!',
      vote: 'Error al votar',
      vinylContest: 'Error al cargar el vinyl contest',
      contact: 'Error al enviar el mensaje',
      addToPlaylist: 'Error al agregar a playlist',
      newPlaylist: 'Error al crear la playlist',
      deletePlaylist: 'Error al eliminar playlist',
      updatePlaylist: 'Error al editar playlist',
      deleteFromPlaylist: 'Error al eliminar track de la playlist',
      deleteTrack: 'Error al eliminar el track',
      noDataPosted: 'Error: Faltan datos',
      authenticationFailed: 'El email y/o la contraseña son incorrectos',
      login: 'Error al iniciar sesión',
      playlist: 'Error al cargar la playlist',
      playlistPrivate: 'Error: la playlist es privada',
      playlistNotFound: 'Error: no se encontró ninguna playlist',
      featuredPlaylist: 'Error al cargar featured playlist',
      artistNotFound: 'Error: no se encontró el artista de featured playlist',
      notSaved: 'Error: no se guardaron los cambios',
      editArtist: 'Error al actualizar los datos del artista',
      notValidToken: 'Error de autenticación',
      track: 'Error al cargar el track',
      likePlaylist: 'Error al hacer me gusta al playlist'
    }
  },

  users: {
    login: 'Iniciar sesión',
    username: 'Nombre de usuario',
    name: 'Nombre | Nombres',
    surnames: 'Apellidos',
    id: 'Número de identificación personal',
    email: 'Email',
    emailConfirmation: 'Confirmar email',
    address: 'Dirección',
    password: 'Contraseña',
    phone: 'Teléfono',
    birthdate: 'Fecha de Nacimiento',
    day: 'Día',
    month: 'Mes',
    year: 'Año',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre',
      'Noviembre', 'Diciembre'],
    code: 'Código',
    voucher: 'Ingresá el código de descuento',
    generateReferralCode: 'Generar Link de Referido',
    choseUserType: 'Selecciona tu perfil',
    textUserType: 'Esta selección puede ser modificada en "Mi Perfil"',
    userType: {
      musicFan: 'Fan',
      producer: 'Artista',
      free: 'Oyente',
      flowArtist: {
        artisticName: 'Nombre artístico',
        text: 'Puedes modificar toda la información personal y artística en "Mi Perfil"'

      }
    },
    registration: {
      shareData: 'Compartir mis datos de registro con los proveedores de contenido de BeatHey para fines de marketing.',
      accept: 'Al hacer click en REGISTRARSE, aceptas los',
      comma: ', la',
      andThe: 'y la',
      register: 'Registrarse',
      alreadyHaveAnAccount: '¿Ya tenés una cuenta?'
    },
    accept: {
      newsLetter: 'Acepto recibir NewsLetter',
      shareInfo: 'Acepto compartir información de contacto con Artistas'
    },
    bio: 'Bio',
    bioDescription: 'Escribe algo sobre tí que te represente',
    country: 'País',
    city: 'Ciudad',
    forgetPassword: {
      question: '¿Olvidaste tu contraseña?',
      success: 'Se envió una nueva contraseña al email ingresado',
      button: 'Recuperar contraseña'
    },
    rememberPassword: '¿Recordaste tu contraseña?',
    changePassword: 'Cambiar contraseña',
    passwordConfirmation: 'Repetir contraseña',
    hasNotFavorites: 'No agregaste ningún track a favoritos',
    editSuccess: 'Se actualizó la información correctamente',
    loginToUnauthorizedUser: 'Para seguir escuchando música, te invitamos a registrarte',
    cancelLoginToUnauthorizedUser: 'Cancelar',
    subscription: {
      title: 'Suscribite!',
      info1: 'Lanzamiento digital de regalo con los mejores 4 artistas del Contest',
      info2: 'Recibir de regalo BeatHey Mag (Sólo para Argentina)',
      info3: 'Si sos artista, tenés la posibilidad de publicar tu música y ser votado en el Contest',
      info4: 'Si sos artista, el 100% de lo recaudado por la venta de música es tuyo',
      info5: 'Si sos artista, podés ser seleccionado para tocar en los eventos BeatHey',
      info6: 'Formas de pago',
      infoEmailNeeded1: 'Por controles internos a MercadoPago, necesitamos la dirección de mail asociada a la billetera (MercadoPago) con la cual realizaremos la operación',
      infoEmailNeeded2: 'Esta información no será almacenada por BeatHey y es de uso exclusivo para esta operación',
      valueTitle: 'Se parte de la comunidad por',
      currency: 'AR$',
      value: '250',
      free: '¡¡Gratuito!!',
      button: 'Suscribirse',
      cancel: 'Cancelar',
      disaffiliate: 'Desafiliarme',
      confirm: 'Confirmar',
      reject: 'Rechazar',
      cancelTitle: '¡Gracias por habernos elegido!',
      cancelMessage: '¿Está seguro de cancelar su suscripción a BeatHey?',
      cancelAccountMessage: '¿Está seguro de cancelar su cuenta BeatHey?',
      cancelAccount: 'Cancela tu cuenta BeatHey.',
      cancelAccountSuccess: 'Tu cuenta BeatHey fue eliminada correctamente.',
      cancelAccountError: 'Hubo un problema eliminando tu cuenta.',
      cancelSubscription: 'Desafiliar tu suscripción recurrente a BeatHey.',
      canceledMPsubSuccess: 'Su suscripción recurrente por Mercado Pago ah sido Cancelada correctamente',
      canceledMPsubError: 'Su suscripción recurrente por Mercado Pago ya ah sido Cancelada',
      voucherCodeMsg: 'Ingresá tu código de Beneficios',
      referredCodeMsg: 'Ingresá tu código de Referido',
      sendEmailNeeded: 'Procesar'
    },
    payment: {
      message: 'Elige una de las opciones de pago'
    },
    userMenu: {
      myProfile: 'Mi Perfil',
      myTracks: 'Mis Tracks',
      myPlaylists: 'Mis Playlist',
      myFavorites: 'Mis Favoritos',
      myShopping: 'Mis Compras',
      myAccount: 'Mi Cuenta',
      help: 'Ayuda',
      terms: 'Términos y Condiciones',
      logout: 'Cerrar Sesión'
    },
    followArtist: 'Ahora sigues a',
    unfollowArtist: 'Dejas de seguir a',
    follow: 'Seguir',
    following: 'Siguiendo',
    copyCodeSucces: 'Se copió el código correctamente',
    copyLinkSucces: 'Se copió el link correctamente',
    copyError: 'Error al copiar'
  },

  artists: {
    seeAll: 'Ver Todos',
    artists: 'Artistas',
    artist: 'Artista | Artistas',
    search: {
      placeholder: 'Buscar por nombre...',
      noMoreResults: 'No hay más resultados'
    },
    info: 'Información del artista',
    name: 'Nombre',
    phrase: 'Bajada',
    text: 'Información',
    hasNotTracks: 'El artista no tiene tracks',
    hasNotPlaylists: 'El artista no tiene playlists',
    hasNotInfo: 'El artista no tiene información',
    section: {
      info: 'Info',
      contact: 'Contacto'
    },
    contact: {
      messagePlaceholder: 'Escribe aquí tu mensaje',
      success: 'Se envió el mensaje correctamente'
    }
  },

  albums: {
    uploadAlbum: 'Subir Album',
    newAlbum: {
      warningMessage: 'Complete los datos del Album para acceder a la carga de Tracks',
      namePlaceholder: 'Nombre del Album',
      uploaded: 'El album se creó correctamente',
      selectFiles: 'Seleccionar archivos',
      uploadButton: 'Subir Album',
      tagsPlaceholder: 'Describe los integrantes que participaron de la elaboración de la obra. Ej: PRODUCTOR, MEZCLA Y MASTERING,ARTE DE TAPA, etc.'
    }
  },

  tracks: {
    seeAll: 'Ver Todos',
    uploadTrack: 'Subir Track',
    track: 'No hay tracks | track | tracks',
    title: 'Título',
    artist: 'Artista',
    genre: 'Género',
    genres: {
      all: 'Todos'
    },
    minPrice: 'Precio Mínimo en U$D',
    release: 'Fecha',
    actions: {
      like: 'Me gusta',
      addToQueue: 'Agregar a la cola',
      buy: 'Comprar',
      share: 'Compartir',
      addToPlaylist: 'Agregar a playlist',
      deleteFromPlaylist: 'Eliminar de playlist',
      edit: 'Editar',
      credits: 'Creditos'
    },
    buyTrack: {
      title: 'Ayudá a ',
      line1: 'Al descargar el track ayudas al artista para que siga trabajando en su música.',
      line2: 'Vos decidís cuánto valorás su música',
      downloadMessage: 'Encontrarás el enlace de descarga del track en la sección "Mis compras" del perfil.',
      values: ['10', '20', '30', '50', '75', '100'],
      valueLabel: 'Importe',
      button: 'Comprar'
    },
    newTrack: {
      button: 'Subir Contenido',
      newRelease: 'Agregar a la lista de NEW RELEASE',
      dropSelectTrack: 'Arrastra o selecciona el archivo del track',
      selectFile: 'Seleccionar archivo',
      dropMessage: 'Soltar archivo para cargarlo',
      important: 'Importante: ',
      info: 'Al compartir, usted confirma que sus sonidos cumplen con nuestras condiciones de uso y que no infrinjan los derechos de cualquier otra persona. En caso de duda, consultar nuestras páginas y preguntas frecuentes información de copyright antes de subir.',
      question1: '¿Problemas para subir archivos?',
      answer1: 'Por favor, consulte nuestras sugerencias para solucionar problemas.',
      question2: '¿Qué tipos de archivos puedo subir?',
      answer2: 'Puede cargar MP3. El tamaño máximo de archivo es de 50MB.',
      extensionMessage: 'El archivo debe ser mp3',
      leaveConfirmation: 'Esta seguro que desea abandonar la página? El Track no está guardado',
      notProducer: 'Para subir tracks debes suscribirte como DJ/Productor!',
      uploaded: 'El track se agregó correctamente',
      imageError: 'La imagen seleccionada supera las dimensiones esperadas, esta debe ser menor a 4024 x 3768 pixeles',
      imageType: 'El archivo debe ser una imagen (jpg,jpeg,png)'
    },
    editTrack: {
      title: 'Sube tu música',
      selectPicture: 'Seleccionar imagen del track',
      completed: 'Carga completa',
      namePlaceholder: 'Nombre del track',
      tagsPlaceholder: 'Describe con palabras el estilo de tu track',
      creditsPlaceholder: 'Agrega los créditos',
      recommendedPlaceHolder: 'Comentanos cuál es tu género musical! Ayudanos a ampliar la familia BeatHey.',
      uploaded: 'El track se actualizó correctamente',
      iswcCode: 'Codigo ISWC Ej: T-xxxxxxxxx-x (opcional)',
      saveChanges: 'Guardar Cambios',
      listUploaded: 'La lista se actualizó correctamente'
    },
    deleteTrack: {
      title: 'Eliminar track',
      success: 'El track ha sido eliminado',
      confirm: '¿Está seguro que desea eliminar el track?'
    },
    shareTrack: {
      title: 'Compartir track',
      copy: 'Copiar',
      success: 'Se copió el link correctamente',
      error: 'Error al copiar el link'
    },
    licenses: {
      features: 'Características de las licencias',
      selected: 'Licencia elegida',
      questions: {
        1: {
          title: '¿Quiere permitir que se compartan adaptaciones de su obra?',
          options: {
            1: 'Sí',
            2: 'No',
            3: 'Sí, siempre que se comparta de la misma manera'
          }
        },
        2: {
          title: '¿Quiere permitir usos comerciales de su obra?',
          options: {
            1: 'Sí',
            2: 'No'
          }
        }
      }
    },
    headers: {
      title: 'Título',
      artist: 'Artista',
      genre: 'Género',
      released: 'Lanzado',
      duration: 'Duración',
      date: 'Comprado'
    }
  },

  playlists: {
    seeAll: 'Ver Todos',
    playlist: 'Playlist | Playlists',
    type: {
      public: 'Pública',
      private: 'Privada'
    },
    isPrivate: 'Esta playlist es privada',
    addToPlaylist: {
      title: 'Agregar a playlist',
      select: 'Selecciona una playlist',
      add: 'Agregar',
      success: 'El track se agregó a la playlist correctamente',
      trackAlreadyExist: 'El track ya existe en esta playlist'
    },
    newPlaylist: {
      button: 'Nueva playlist',
      title: 'Crear nueva playlist',
      imageError: 'Error al cargar la imagen de la playlist',
      playlistName: 'Título playlist',
      saveAndAdd: 'Guardar y agregar',
      success: 'Se creó la playlist correctamente'
    },
    delete: {
      confirm: '¿Está seguro que desea eliminar la playlist?',
      success: 'Se eliminó la playlist correctamente',
      title: 'Eliminar Playlist'
    },
    edit: {
      title: 'Editar playlist',
      button: 'Editar',
      success: 'Se modficó la playlist correctamente'
    },
    deleteTrackFromPlaylist: {
      title: 'Eliminar track de la playlist',
      success: 'El track ha sido eliminado de la playlist',
      confirm: '¿Está seguro que desea eliminar el track de la playlist?'
    },
    sharePlaylist: 'Compartir playlist',
    like: {
      button: 'me gusta'
    }
  },

  vinylContest: {
    noArtist: 'No se han votado artistas aún',
    vote: 'Votar',
    success: 'Tu voto fue registrado!',
    link: 'Ir al Contest',
    title: 'Contest',
    closeIn: 'Cierra en:',
    day: 'día | días',
    hour: 'hora | horas',
    minute: 'minutos | minuto | minutos'
  },

  payment: {
    mpConnect: {
      info: 'Conectate a Mercado Pago para recibir el 100% de las ventas de tus tracks, sin intermediarios, directamente en tu cuenta personal.',
      title: 'Cobra mediante Mercado Pago la venta de tus tracks!',
      connectedAs: 'Conectado como',
      disconnectInfo: 'Para eliminar la conexión debe ingresar a ',
      nickname_title_help: 'Esta información la verá el comprador al momento de pagar. Te recomendamos que se relacione con el artista.'
    },
    connect: 'Conectar',
    paypal: {
      subscriptionSuccess: 'Su subscripción se generó exitosamente'
    }
  },

  help: {
    title: '¿Cómo te podemos ayudar?',
    contactInformation: 'Información de contacto',
    whatsapp: '+54 911 5574 0051',
    email: 'contacto@BeatHey.com',
    contactForm: {
      title: 'Envianos tu consulta',
      success: 'Se envió la consulta correctamente'
    },
    unsubscribe: 'Recuerda, para darte de baja con ',
    send: 'envía ',
    to: 'al ',
    faqs: 'Preguntas frecuentes'
  },

  uploadPicture: {
    selectPicture: 'Seleccionar imagen'
  },

  footer: {
    termsOfUse: 'Términos y condiciones de uso',
    intellectuallyProp: 'Política de propiedad intelectual',
    privacyPolicy: 'Política de privacidad y cookies',
    help: 'Ayuda',
    contact: 'Contacto',
    company: 'Empresa',
    language: {
      title: 'Idioma',
      spanish: 'Español',
      english: 'English',
      portuguese: 'Português'
    }
  },
  ads: {
    advertisingSpace: 'Espacio publicitario'
  },
  landing: {
    plans: 'Planes',
    music: 'Música',
    title: ' sin intermediarios',
    subtitle: 'Los ingresos son 100% para el artista',
    leyend: 'Comienza a cambiar vidas',
    button1: 'Oyendo',
    button2: 'Creando',
    join: 'Sumate!',
    joinText: 'Conocé nuestros',
    description: {
      t1: 'Los ingresos',
      t2: 'son 100%',
      t3: 'para el artista'
    },
    oyendo: {
      title: 'No Solo Oyendo',
      carousel: {
        text1: 'Apoyas, ayudas y construyes comunidad, Escuchando, Compartiendo, Comprando y Votando',
        text2: 'Somos una comunidad de artistas independientes, y tu ayuda va directamente a cada uno de nosotros, sin intermediarios',
        text3: 'Estamos creando un nuevo concepto en la industria de la música y queremos que seas parte.'
      },
      button: 'Planes'
    },
    creando: {
      title: 'Incubando talentos',
      carousel: {
        text1: 'Tu esfuerzo se monetiza, cuanto más te escuhan, más te votan, más se vende tu música, más exposición vas a tener.',
        text2: 'Eres el dueño de tus derechos, vende tu música sin intermediarios, obtén votos de la comunidad en el contest trimestral y sé parte de nuestra revista.',
        text3: 'Somos una comunidad de artistas independientes, creando un nuevo concepto en la industria de la música en el que somos los protagonistas. ¡Vívelo con nosotros!'
      },
      button: 'Planes'
    },
    planes: {
      title: 'Tu suscripción genera el cambio.',
      leyend: 'Lo recaudado con las suscripciones se distribuye a los artistas bajo el concepto de “pago por streaming”. De esta forma, tu suscripción está impactando directamente en ellos, generándoles más oportunidades.',
      free: {
        text1: 'Escuchar Música',
        text2: 'Publicidad inherente a BeatHey',
        text3: 'Comprar Música'
      },
      fan: {
        text1: 'Marcar Favoritos',
        text2: 'Votar en Contest',
        text3: 'Escuchar sin Publicidad',
        text4: 'Lanzamientos Digitales de ganadores de contest de forma gratuita',
        text5: 'Revista BeatHey Mag, física y/o digital de forma gratuita',
        text6: 'Descuentos de hasta el 60% en tickets de festivales BeatHey'
      },
      artist: {
        header: 'Todos los Beneficios del Fan y más...',
        text1: 'Subir música y monetizarla',
        text2: 'Recibir el doble de ingresos por reproducción (pago por streaming)',
        text3: 'Posibilidad de presentaciones en festivales BeatHey bajo aval del equipo de curaduría'
      }
    }
  },
  dashboard: {
    title: 'Dashboard',
    apply: 'Aplicar',
    upload: 'Canciones Subidas',
    daysWithoutUpload: 'Dias sin subir Canciones',
    avg: 'Promedio Subidas Mensuales',
    likes: 'Me Gusta',
    followers: 'Seguidores',
    reproductionsRanking: 'Ranking de Reproducciones',
    songRanking: 'Detalle de reproducciones',
    trackName: 'Nombre Canción',
    duration: 'Duración',
    atention: 'Atención...',
    warning: 'Esta herramienta te permite acceder a información de lo que sucede con tus obras y así poder tomar decisiones. Suscríbete a través del botón "Subir Contenido" para acceder al 100% de la información disponible.',
    tooltipAdmin: 'Sos un Administrador.',
    tooltipArtist: 'Sos un Artista.',
    tooltipSubscribed: 'Estas Subscripto.',
    tableName: 'Nombre',
    tableArtist: 'Artista',
    tableRepro: 'Reproducciones',
    tableLikes: 'Me Gusta'
  },
  localContent: {
    title: 'EN VIVO',
    category: 'Categoría'
  }
}



// WEBPACK FOOTER //
// ./src/translator/es.js